/**
 * IntegrationsList
 *
 * List component for displaying all analytics integrations.
 *
 * @module analytics-settings/components
 */

import React from 'react';
import { Box } from '@mui/material';
import type { AnalyticsIntegration } from '../types/analytics.types';
import { IntegrationCard } from './IntegrationCard';

export interface IntegrationsListProps {
  integrations: AnalyticsIntegration[];
  onUpdate: (
    integrationId: string,
    updates: Partial<Omit<AnalyticsIntegration, 'id' | 'createdAt'>>
  ) => Promise<void>;
  onDelete: (integrationId: string) => Promise<void>;
  onToggle: (integrationId: string, enabled: boolean) => Promise<void>;
  disabled?: boolean;
  /** Project ID - required for server-side platforms (Facebook CAPI test events) */
  projectId?: string;
}

/**
 * IntegrationsList - List of integration cards
 */
export const IntegrationsList: React.FC<IntegrationsListProps> = ({
  integrations,
  onUpdate,
  onDelete,
  onToggle,
  disabled = false,
  projectId,
}) => {
  return (
    <Box>
      {integrations.map((integration) => (
        <IntegrationCard
          key={integration.id}
          integration={integration}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onToggle={onToggle}
          disabled={disabled}
          projectId={projectId}
          siblingIntegrations={integrations}
        />
      ))}
    </Box>
  );
};

export default IntegrationsList;
